var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logo-wrapper"},[_c('Logo'),_c('div',{staticClass:"back-btn",on:{"click":_vm.toggle_sidebar}},[_c('i',{staticClass:"fa fa-angle-left"})])],1),_c('div',{staticClass:"logo-icon-wrapper"},[_c('Logo')],1),_c('Nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }